// Types
import { Matrix3D } from 'rematrix';
import { Point } from '../../../common/maths/geometry/pointTypes';
import { Rect, RectSize } from '../../../common/maths/geometry/rect/rectTypes';

/**
 * Determines if a number is finite and positive enough to use as a scale.
 */
export const isFiniteScale = (scale: number | null | undefined): scale is number => Number.isFinite(scale) && scale > 0;

/**
 * Determines if a point contains only finite coordinates.
 */
export const isFinitePoint = (point: Point | null | undefined): point is Point =>
    Number.isFinite(point?.x) && Number.isFinite(point?.y);

/**
 * Determines if a rect size contains only finite dimensions.
 */
export const isFiniteRectSize = (rectSize: RectSize | null | undefined): rectSize is RectSize =>
    Number.isFinite(rectSize?.width) && Number.isFinite(rectSize?.height);

/**
 * Determines if a rect contains only finite dimensions and positions.
 */
export const isFiniteRect = (rect: Rect | null | undefined): rect is Rect =>
    isFiniteRectSize(rect) &&
    Number.isFinite(rect?.x) &&
    Number.isFinite(rect?.y) &&
    Number.isFinite(rect?.left) &&
    Number.isFinite(rect?.top) &&
    Number.isFinite(rect?.right) &&
    Number.isFinite(rect?.bottom);

/**
 * Determines if a transform matrix contains only finite values.
 */
export const isFiniteMatrix = (matrix: Matrix3D | null | undefined): matrix is Matrix3D =>
    Array.isArray(matrix) && matrix.every(Number.isFinite);
